import SpaceBetween from "@awsui/components-react/space-between";
import React, {useState} from "react";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import FormField from "@awsui/components-react/form-field";
import Form from "@awsui/components-react/form";
import Input from "@awsui/components-react/input";
import Select from "@awsui/components-react/select";
import Button from "@awsui/components-react/button";
import Box from "@awsui/components-react/box";
import Link from "@awsui/components-react/link";
import SubmitFlashbar from "components/SubmitFlashbar";
import NewRider from "model/admin/NewRider";
import AddRiderButton from "pages/admin/pages/add_rider/components/AddRiderButton";
import {COUNTRIES_MAP} from "common/const";


// Countries must be stored under the same full names the rest of the app uses:
// FlagIcon looks the value up in COUNTRIES_MAP to resolve a flag, and
// SetBasquenessPage compares against "Spain" / "France" / "Basque Country".
// A free-text field would let a UCI code like "SLO" through and silently break
// flag rendering, so this is a closed list.
const COUNTRY_OPTIONS = [...COUNTRIES_MAP.keys()]
    .sort((a, b) => a.localeCompare(b))
    .map(country => ({label: country, value: country}));

const AddRiderPage: React.FC = () => {

    const [rider, setRider] = useState<NewRider>({});
    const [buttonEnabled, setButtonEnabled] = useState(true);
    const [submitMessage, setSubmitMessage] = useState<FlashbarProps.MessageDefinition>();

    const changeRider = (newRider: NewRider): void => {
        setRider(newRider);
        setButtonEnabled(true);
    }

    return (
        <SpaceBetween size="l">
            <NavigationBar/>
            <Container
                header={
                    <Box variant={"span"}>
                        <Header variant="h1">Add rider</Header>
                        <Link variant={"info"} href={"/admin"}>Back</Link>
                    </Box>
                }
            >
                <SpaceBetween size={"m"}>
                    {submitMessage && (
                        <SubmitFlashbar
                            submitMessage={submitMessage}
                            setSubmitMessage={setSubmitMessage}
                        />
                    )}
                    <form onSubmit={e => e.preventDefault()}>
                        <Form
                            actions={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Button formAction="none" variant="link" href="/admin">
                                        Cancel
                                    </Button>
                                    <AddRiderButton
                                        rider={rider}
                                        setRider={setRider}
                                        buttonEnabled={buttonEnabled}
                                        setButtonEnabled={setButtonEnabled}
                                        setSubmitMessage={setSubmitMessage}
                                    />
                                </SpaceBetween>
                            }
                        >
                            <SpaceBetween direction="vertical" size="l">
                                <FormField key={"name"} label={<Header variant="h2">Name</Header>}>
                                    <Input
                                        inputMode="text"
                                        onChange={({detail}) => changeRider({...rider, name: detail.value})}
                                        value={rider.name || ""}
                                        disableBrowserAutocorrect
                                        placeholder="Tadej Pogačar"
                                    />
                                </FormField>
                                <FormField key={"country"} label={<Header variant="h2">Country</Header>}>
                                    <Select
                                        selectedOption={
                                            rider.country
                                                ? {label: rider.country, value: rider.country}
                                                : null
                                        }
                                        onChange={({detail}) => changeRider({
                                            ...rider,
                                            country: detail.selectedOption.value
                                        })}
                                        options={COUNTRY_OPTIONS}
                                        filteringType="auto"
                                        placeholder="Select a country (optional)"
                                        selectedAriaLabel="Selected"
                                    />
                                </FormField>
                                <FormField key={"img"} label={<Header variant="h2">Image URL</Header>}>
                                    <Input
                                        inputMode="url"
                                        onChange={({detail}) => changeRider({...rider, img: detail.value})}
                                        value={rider.img || ""}
                                        disableBrowserAutocorrect
                                    />
                                </FormField>
                                <FormField key={"link"} label={<Header variant="h2">Link</Header>}>
                                    <Input
                                        inputMode="url"
                                        onChange={({detail}) => changeRider({...rider, link: detail.value})}
                                        value={rider.link || ""}
                                        disableBrowserAutocorrect
                                    />
                                </FormField>
                            </SpaceBetween>
                        </Form>
                    </form>
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    )
};

export default AddRiderPage;
